export const SKELETON = {
  SHAPE: {
    CIRCLE: "circle",
    ROUND: "round",
    SQUARE: "square",
    DEFAULT: "default",
  },
};